<app-spinner-service></app-spinner-service>

<div class="p-grid">
  <div class="p-col-12">
    <p-toolbar>
      <div class="p-toolbar-group-left">
        <button pButton label="Adicionar Saldo Inicial" icon="pi pi-plus" (click)="openNew()"></button>
      </div>
      <div class="p-toolbar-group-right">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </p-toolbar>
    <p-confirmDialog></p-confirmDialog>
    <p-table #dt [value]="saldoInicialArray" [paginator]="true" [rows]="10" selectionMode="single"
      [(selection)]="selectedSaldoInicial" [globalFilterFields]="['data', 'valor', 'contaFilhaId']"
      currentPageReportTemplate="{first} de {last} de {totalRecords} registros" class="custom-table">
      <ng-template pTemplate="header">
        <tr class="table-header">
          <th pSortableColumn="data" class="header-cell" style="flex: 3">
            Data do Saldo Inicial
            <p-sortIcon field="data"></p-sortIcon>
          </th>
          <th pSortableColumn="valor" class="header-cell" style="flex: 3">
            Valor do Saldo Inicial
            <p-sortIcon field="valor"></p-sortIcon>
          </th>
          <th pSortableColumn="contaFilhaId" class="header-cell" style="flex: 2">
            Conta Filha
            <p-sortIcon field="contaFilhaId"></p-sortIcon>
          </th>
          <th class="actions-cell">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-saldoInicial>
        <tr>
          <td [pTooltip]="formataData(saldoInicial.data)" tooltipPosition="top" style="word-break: break-word">
            {{ formataData(saldoInicial.data) }}
          </td>
          <td [pTooltip]="" tooltipPosition="top" style="word-break: break-word">
            {{ ajustaTamanhoCampo(saldoInicial?.contaFilhaId) }}
          </td>
          <td [pTooltip]="getContaFilhaName(saldoInicial.contaFilhaId)" tooltipPosition="top"
            style="word-break: break-word">
            {{
            ajustaTamanhoCampo(getContaFilhaName(saldoInicial.contaFilhaId))
            }}
          </td>
          <td class="actions" style="text-align: right">
            <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-warning mr-2"
              (click)="editSaldoInicial(saldoInicial)"></button>
            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"
              (click)="deleteSaldoInicial(saldoInicial)"></button>
            <button pButton icon="pi pi-info-circle" class="p-button-rounded p-button-info"
              (click)="viewDetails(saldoInicial)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<app-generic-dialog [visible]="saldoInicialDialog"
  [dialogTitle]="isEdit ? 'Editar Saldo Inicial' : 'Adicionar Saldo Inicial'" [formGroup]="saldoInicialForm"
  [submitButtonLabel]="isEdit ? 'Salvar Alterações' : 'Salvar'" [imageSrc]="caminhoImagem"
  (submit)="salvarSaldoInicial()" (cancel)="onCancel()">
  <div form-fields>
    <div class="p-field">
      <label for="data">Data</label>
      <p-calendar id="dataSaldoInicial" formControlName="data" [showTime]="false" [showIcon]="true"
        placeholder="Selecione a data" dateFormat="dd/mm/yy"></p-calendar>
    </div>
    <div class="p-field" style="width: 250px">
      <label for="valor">Valor do Saldo Inicial</label>
      <input id="valor" type="text" pInputText formControlName="valor" mask="separator.2" prefix="R$ "
        thousandSeparator="." decimalMarker="," />
    </div>
    <div class="p-field">
      <label for="contaFilhaId">Conta Filha</label>
      <p-dropdown id="contaFilhaId" formControlName="contaFilhaId" [options]="classificacaoOptions"
        placeholder="Selecione a Conta Filha">
      </p-dropdown>
    </div>
  </div>
</app-generic-dialog>

<p-dialog
  [(visible)]="detailsDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes do Saldo Inicial"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '900px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
  <div class="dialog-content-wrapper" *ngIf="selectedSaldoInicial">
    <div class="detail-card">
      <div class="detail-header">
        <div class="header-icon"><i class="pi pi-wallet"></i></div>
        <div class="header-info">
          <h2 class="detail-title">{{ getContaFilhaName(selectedSaldoInicial.contaFilhaId) }}</h2>
          <p class="detail-subtitle">Saldo Inicial · {{ formataData(selectedSaldoInicial.data) }}</p>
        </div>
      </div>

      <div class="resumo-valores">
        <div class="valor-card valor-card--neutro">
          <div class="valor-card__icon"><i class="pi pi-dollar"></i></div>
          <div class="valor-card__content">
            <span class="valor-card__label">Valor do Saldo</span>
            <span class="valor-card__value">{{ selectedSaldoInicial.valor | currency:'BRL' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações</span></div>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-calendar"></i><span>Data do Saldo Inicial</span></div>
            <div class="detail-value">{{ formataData(selectedSaldoInicial.data) }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-dollar"></i><span>Valor</span></div>
            <div class="detail-value">{{ selectedSaldoInicial.valor | currency:'BRL' }}</div>
          </div>
          <div class="detail-item full-width">
            <div class="detail-label"><i class="pi pi-book"></i><span>Conta Filha</span></div>
            <div class="detail-value">{{ getContaFilhaName(selectedSaldoInicial.contaFilhaId) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="detailsDialogVisible = false"></button>
  </ng-template>
</p-dialog>